import script from "./FiltersModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FiltersModal.vue?vue&type=script&setup=true&lang=ts"

import "./FiltersModal.vue?vue&type=style&index=0&id=9a06a6b0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a06a6b0"]])

export default __exports__